<template>
  <div :class="['header',headerBlue?'headerBlue':'']  ">
    <div class="header-container">
      <div class="header-logo-container" @click="toHome($event)">
        <img class="header-logo" src="../assets/xlh_logo.png">
      </div>
      <div class="header-content-center">
        <div class="header-title" @click="toHome($event)">首页</div>
        <div class="header-title" @click="toAboutUs($event)">关于我们</div>
        <div class="header-title" @click="toArticle($event)">动态</div>
        <div class="header-title" @click="toVideo($event)">视频</div>
        <div class="header-title" @click="toContactUs($event)">联系我们</div>
        <div class="clearboth"></div>
      </div>
      <div class="header-content-right">
        <div class="header-title header-offer" @click="toQuotation($event)">获取报价</div>
        <div class="header-title header-offer" style="padding: 8px 20px;margin-left: 10px;background: #3b90fa;" @click="toSaas($event)">合作客户登录</div>
        <div class="clearboth"></div>
      </div>
    </div>
    <div class="header-line"></div>
    <div id="randomCode" style="display: none;"></div>
  </div>
  
</template>

<script>
  import axios from "axios";

  export default {
    data() {
      return {
        time: 0,
      }
    },
    props: {
      headerBlue: {
        type: Boolean,
        default: ()=>{
          return false;
        },
      }
    },
    created(){

    },
    mounted(){
      setInterval(()=>{
        this.time = this.time + 1
      },1000);
      let excludes = {};
      let options = {
        excludes: excludes
      }
    },
    methods: {
      toHome(e){
        let scrollTop = document.documentElement.scrollTop;
        let x = e.x;
        let y = Math.floor(e.y + scrollTop);
        this.toVisitPage(this.$route.path,'/',0,0,x,y)
        this.$router.push('/');
      },
      toAboutUs(e){
        let scrollTop = document.documentElement.scrollTop;
        let x = e.x;
        let y = Math.floor(e.y + scrollTop);
        this.toVisitPage(this.$route.path,'/aboutUs',0,0,x,y)
        this.$router.push('/aboutUs');
      },
      toContactUs(e){
        let scrollTop = document.documentElement.scrollTop;
        let x = e.x;
        let y = Math.floor(e.y + scrollTop);
        this.toVisitPage(this.$route.path,'/contactUs',0,0,x,y)
        this.$router.push('/contactUs');
      },
      toQuotation(e){
        let scrollTop = document.documentElement.scrollTop;
        let x = e.x;
        let y = Math.floor(e.y + scrollTop);
        this.toVisitPage(this.$route.path,'/quotation',0,0,x,y)
        this.$router.push('/quotation');
      },
      toSaas(e){
        let scrollTop = document.documentElement.scrollTop;
        let x = e.x;
        let y = Math.floor(e.y + scrollTop);
        this.toVisitPage(this.$route.path,'saas',0,0,x,y)
        window.location.href = "http://saas.hfwb1997.com/XLH/";
      },
      toArticle(e){
        let scrollTop = document.documentElement.scrollTop;
        let x = e.x;
        let y = Math.floor(e.y + scrollTop);
        this.toVisitPage(this.$route.path,'/article',0,0,x,y)
        this.$router.push('/article');
      },
      toVideo(e){
        let scrollTop = document.documentElement.scrollTop;
        let x = e.x;
        let y = Math.floor(e.y + scrollTop);
        this.toVisitPage(this.$route.path,'/video',0,0,x,y)
        this.$router.push('/video');
      },
      
      toVisitPage(fromPagePath,toPagePath,buttonId,resourceId,coordinateX,coordinateY){
        let params = {};
        let fromPage = 0
        let toPage = 0
        //页面1首页2关于我们3动态4视频5联系我们6获取报价
        //按钮1免费上门评估2上门评估预约3获取报价提交
        if(fromPagePath=='/'){
          fromPage = 1
        }else if(fromPagePath=='/aboutUs'){
          fromPage = 2
        }else if(fromPagePath=='/article'){
          fromPage = 3
        }else if(fromPagePath=='/video'){
          fromPage = 4
        }else if(fromPagePath=='/contactUs'){
          fromPage = 5
        }else if(fromPagePath=='/quotation'){
          fromPage = 6
        }else if(fromPagePath=='/articleInfo'){
          fromPage = 10
        }else if(fromPagePath=='/videoInfo'){
          fromPage = 11
        }
        if(toPagePath=='/'){
          toPage = 1
        }else if(toPagePath=='/aboutUs'){
          toPage = 2
        }else if(toPagePath=='/article'){
          toPage = 3
        }else if(toPagePath=='/video'){
          toPage = 4
        }else if(toPagePath=='/contactUs'){
          toPage = 5
        }else if(toPagePath=='/quotation'){
          toPage = 6
        }else if(toPagePath=='saas'){
          toPage = 7
        }else if(toPagePath=='hfwb1997'){
          toPage = 8
        }else if(toPagePath=='hf1997'){
          toPage = 9
        }else if(toPagePath=='/articleInfo'){
          toPage = 10
        }else if(toPagePath=='/videoInfo'){
          toPage = 11
        }

        if(buttonId==null){
          buttonId = 0
        }
        if(resourceId==null){
          resourceId = 0
        }
        if(coordinateX==null){
          coordinateX = 0
        }
        if(coordinateY==null){
          coordinateY = 0
        }
        params.fromPage = fromPage;
        params.toPage = toPage;
        params.button = buttonId;
        params.resourceId = resourceId;
        params.coordinateX = coordinateX;
        params.coordinateY = coordinateY;
        params.time = this.time;
        params.sessionId = sessionStorage.getItem("Finger");//浏览器标识
        axios
        .post("pilotage/webVisit", params)
        .then((res) => {
        })
        .catch((res) => {});
      }


    }

  }
</script>
<style>
  .clearboth {
    clear: both;
  }

  .header {
    background: transparent;
    height: 96px;
    position: relative;
  }

  .header.headerBlue {
    background: #00368A;
    box-shadow: 0px 1px 10px rgba(16, 85, 193, 0.1);
  }

  .header.headerBlue .header-line {
    background: transparent;
  }

  .header-container {
    width: calc(100% - 160px);
    height: calc(100% - 0.5px);
    margin: auto;
    position: relative;
  }

  .header-logo-container {
    position: absolute;
    top: 25px;
    left: 0px;
    cursor: pointer;
  }

  .header-logo {
    height: 43px;
    width: auto;
  }

  .header-line {
    height: 0.5px;
    width: calc(100% - 160px);
    /*margin: auto;*/
    background: #FFFFFF;
    position: absolute;
    top: 95.5px;
    left: 80px;
  }

  .header-content-center {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .header-content-right {
    position: absolute;
    top: 50%;
    right: 0;
    transform: translateY(-50%);
  }

  .header-content-center .header-title:first-child {
    margin-left: 0px;
  }

  .header-title {
    color: #FFFFFF;
    float: left;
    margin-left: 40px;
    font-size: 16px;
    line-height: 24px;
    font-family: Noto Sans SC;
    cursor: pointer;
  }

  .header-content-right .header-title {
    font-size: 14px;
    border-radius: 8px;
    background: transparent;
    padding: 8px 36px;
    margin-left: -6px;
  }

  .header-content-right .header-title.header-offer {
    background: #1055C1;
    margin: 0px;
    font-weight: 500;
  }
</style>



// WEBPACK FOOTER //
// src/components/Header.vue